import { LanguageService } from './../../../Services/languageService';
import { userService } from './../../../Services/userService';
import { Subscription } from 'rxjs';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { BindMdl } from '../../../Models/BindMdl';
import { MotorProposal } from '../../../Models/MotorProposal';
import { OnInit } from '@angular/core';
import { restURL } from '../../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AddNewPolicyReqMdl } from '../../../Models/AddNewPolicyReqMdl';
import { motorProposalService } from '../../../Services/motorProposalService';
import { MotorStepService } from '../../../Services/MotorStepService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';



@Component({
  selector: 'MotorProposalForm',
  templateUrl: './MotorProposalForm.html',
  styleUrls: ['./MotorProposalForm.css']
})
export class MotorProposalForm {

  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public isShowLoading: boolean = false;
  public newPolicyReq: AddNewPolicyReqMdl = new AddNewPolicyReqMdl();
  public bindObj: BindMdl = new BindMdl();
  public prObj: MotorProposal = new MotorProposal();
  public FirstStep: boolean = false;
  public SecondStep: boolean = false;
  public ThirdStep: boolean = false;
  public FourthStep: boolean = false;
  public motorStepInfoSubscription: Subscription;
  public StepNumber: number;
  public LngSubscription: Subscription;
  public Lng: string;
  public ReviewInfo: boolean = false;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public InsGender: string;
  public InsGenderAr: string;
  public InsMaritalStatus: string;
  public InsMaritalStatusAr: string;
  public InsNationality: string;
  public InsNationalityAr: string;
  public VehicleColorEn: string;
  public VehicleColorAr: string;

  constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private proposalService: motorProposalService, private motorStepService: MotorStepService, private userinfo: userService, private lngService: LanguageService) {
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    this.motorStepInfoSubscription = this.motorStepService.getStepNum().subscribe(StepNumber => {
      this.StepNumber = Number(StepNumber);
      this.setProgressbar(this.StepNumber);

    });


    if (sessionStorage.getItem("mp") === null) {
      this.BindInfo();
    }
    else {
      this.bindObj = this.proposalService.getBindObj();
      this.prObj = this.proposalService.getProposalObj();
      this.InsGender = this.bindObj.GenderList.filter(t => t.gendercode == this.prObj.Gender)[0].genderdesc_En;
      this.InsGenderAr = this.bindObj.GenderList.filter(t => t.gendercode == this.prObj.Gender)[0].GenderDesc_Ar;
      this.InsNationality = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.prObj.addressObj.Insured_Nationality)[0].NationalityDescEn;
      this.InsNationalityAr = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.prObj.addressObj.Insured_Nationality)[0].NationalityDescAr;
      this.VehicleColorEn = this.bindObj.VechileColorList.filter(t => t.ColorId == Number(this.prObj.vehcileObj.Vehicle_ColorID))[0].ColorDescEn;
      this.VehicleColorAr = this.bindObj.VechileColorList.filter(t => t.ColorId == Number(this.prObj.vehcileObj.Vehicle_ColorID))[0].ColorDescAr;

    }
  }

  setProgressbar(stepNo: number) {
    if (stepNo == 4) {
      this.FirstStep = true;
      this.SecondStep = true;
      this.ThirdStep = true;
      this.FourthStep = true;
    }
    else if (stepNo == 3) {
      this.FirstStep = true;
      this.SecondStep = true;
      this.ThirdStep = true;
      this.FourthStep = false;
    }
    else if (stepNo == 2) {
      this.FirstStep = true;
      this.SecondStep = true;
      this.ThirdStep = false;
      this.FourthStep = false;
    }
    else if (stepNo == 1) {
      this.FirstStep = true;
      this.SecondStep = false;
      this.ThirdStep = false;
      this.FourthStep = false;

    }
    else {
      this.FirstStep = false;
      this.SecondStep = false;
      this.ThirdStep = false;
      this.FourthStep = false;
    }
  }
  BindInfo() {
    this.isShowLoading = true;
    this.newPolicyReq = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("newPolicyObj")));
    this.isShowLoading = true;
    if (this.newPolicyReq.RegNo == undefined) {
      this.newPolicyReq.RegNo = sessionStorage.getItem("RegNo");
    }
    this.newPolicyReq.RegNo = this.userinfo.EncriptString(this.newPolicyReq.RegNo).toString();

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.newPolicyReq));

    //this.http.post<BindMdl>(this.url.baseURL + "/newPolicy/bindInfo", this.newPolicyReq, this.userinfo.getHttpOptions())
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/newPolicy/bindInfo", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        //this.bindObj = result;
        //New Line Start
        this.objPayloadResponse = result;

        let objResObj: BindMdl = new BindMdl();
        objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        if (this.userinfo.EncriptString(objResObj.MotorProposalObj.RegNo).toString() != this.newPolicyReq.RegNo) {
          Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
          this.router.navigate(['BeforeLogin/NewReg']);
          return;
        }
        this.bindObj = objResObj;
        if (this.bindObj.st.StatusCode == "F") {
          this.Lng == "ar" ? Swal(this.bindObj.st.StatusDescAr) : Swal(this.bindObj.st.StatusDesc);
          this.router.navigate(['NewDashboard/Welcome']);
          return;
        }
        //NewLine End

        this.prObj = this.bindObj.MotorProposalObj;
        this.InsGender = this.bindObj.GenderList.filter(t => t.gendercode == this.prObj.Gender)[0].genderdesc_En;
        this.InsGenderAr = this.bindObj.GenderList.filter(t => t.gendercode == this.prObj.Gender)[0].GenderDesc_Ar;
        this.InsMaritalStatus = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.prObj.Ins_MaritalStatus)[0].MarstatusDesc_En;
        this.InsMaritalStatusAr = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.prObj.Ins_MaritalStatus)[0].MarstatusDesc_Ar;
        this.InsNationality = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.prObj.addressObj.Insured_Nationality)[0].NationalityDescEn;
        this.InsNationalityAr = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.prObj.addressObj.Insured_Nationality)[0].NationalityDescAr;
        this.VehicleColorEn = this.bindObj.VechileColorList.filter(t => t.ColorId == Number(this.prObj.vehcileObj.Vehicle_ColorID))[0].ColorDescEn;
        this.VehicleColorAr = this.bindObj.VechileColorList.filter(t => t.ColorId == Number(this.prObj.vehcileObj.Vehicle_ColorID))[0].ColorDescAr;


        if (this.prObj.isEditProposal == false) {
          this.prObj.InsuredEducation = "5";
          this.prObj.InsuredProfessin = "1";
          this.prObj.insuredDriverObj.RoadConvictions = 74;
          this.prObj.vehcileObj.Vehicle_Mileage = "2";
          this.prObj.vehcileObj.MileagePerYear = "1";
          this.prObj.insuredDriverObj.SaudiLicenceHeld = "-1";
          this.prObj.insuredDriverObj.OtherCountriesLicenceHeld = "341";
          this.prObj.ChildrenUnder = "1";
          this.prObj.insuredDriverObj.NumberOfYearsEachCountry = "1";
          this.prObj.insuredDriverObj.DriverMedicalConditions = "7";
          this.prObj.addressObj.OfficeCity = this.prObj.addressObj.OfficeCity == null ? "0" : this.prObj.addressObj.OfficeCity;
          this.prObj.addressObj.OfficeStreet = this.prObj.addressObj.OfficeStreet == "0" ? null : this.prObj.addressObj.OfficeStreet;
          this.prObj.addressObj.OfficeUnitNo = this.prObj.addressObj.OfficeUnitNo == 0 ? null : this.prObj.addressObj.OfficeUnitNo;
          this.prObj.DeductableCode = "";
        }
        this.prObj.addressObj.OfficeCity = this.prObj.addressObj.OfficeCity == null ? "0" : this.prObj.addressObj.OfficeCity;
        this.prObj.addressObj.OfficeStreet = this.prObj.addressObj.OfficeStreet == "0" ? null : this.prObj.addressObj.OfficeStreet;
        this.prObj.addressObj.OfficeUnitNo = this.prObj.addressObj.OfficeUnitNo == 0 ? null : this.prObj.addressObj.OfficeUnitNo;

        //this.prObj.ProposalEffTo = new Date(this.GetDate(this.prObj.ProposalEffFrom));
        //this.prObj.ProposalEffTo.setDate(this.prObj.ProposalEffTo.getDate() - 1);
        this.prObj.ProposalEffTo = this.prObj.ProposalEffTo;
        this.prObj.IsRenewal = this.newPolicyReq.IsRenewal;
        this.prObj.PrvPolicyNo = this.newPolicyReq.PrvPolicyNo;


        this.proposalService.saveProposalObj(this.prObj);
        this.proposalService.saveBindObj(this.bindObj);
        this.proposalService.sendProposal(this.prObj);
        this.proposalService.sendBindInfo(this.bindObj);
        this.isShowLoading = false;

        if (this.prObj.trackingObj.ScreenNo === "P") {
          sessionStorage.setItem("mp", "Y");
          sessionStorage.setItem("CurrentRoute", "PremiumInfo");
          this.router.navigate(['NewDashboard/MotorProposalForm/PremiumInfo']);
        }
        else if (this.prObj.trackingObj.ScreenNo === "D") {
          sessionStorage.setItem("mp", "Y");
          sessionStorage.setItem("CurrentRoute", "DriverInfo");
          this.router.navigate(['NewDashboard/MotorProposalForm/DriverInfo']);
        }
        else if (this.prObj.trackingObj.ScreenNo === "R") {
          sessionStorage.setItem("mp", "Y");
          sessionStorage.setItem("CurrentRoute", "ReviewConfirm");
          this.router.navigate(['NewDashboard/MotorProposalForm/ReviewConfirm']);
        }

      },
        (error) => {
          this.isShowLoading = false;
          this.userinfo.checkTokenStatus(error);
        })


  }

  GetDate(val): string {

    var d = new Date(val),
      month = '' + (d.getMonth() + 1),
      day = '' + (d.getDate()),
      year = '' + (d.getFullYear() + 1);

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return year + "-" + month + "-" + day;

  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/MotorProposalForm/MotorProposalForm.ts